import { isSpSize } from "../common/utils/isSpSize";

const init = () => {
  const $main = document.querySelector("#area_map");

  if (!$main) return;

  const $points = $main.querySelectorAll(".js-point");
  const $list = $main.querySelectorAll(".js-list");

  const activatePoint = (targetId, companyName) => {
    gsap.utils.toArray($points).forEach((elm) => {
      const myId = elm.dataset.id;
      if (!myId) return;
      if (targetId == myId) {
        elm.classList.add("-active");
        if (companyName.includes("アシレ")) {
          $('[data-id="25"]').addClass("-active");
        }
        return;
      }
    });
  };

  const inactivatePoint = (targetId, companyName) => {
    gsap.utils.toArray($points).forEach((elm) => {
      const myId = elm.dataset.id;
      if (!myId) return;
      if (targetId == myId) {
        elm.classList.remove("-active");
        if (companyName.includes("アシレ")) {
          $('[data-id="25"]').removeClass("-active");
        }
        return;
      }
    });
  };

  gsap.utils.toArray($list).forEach((elm) => {
    elm.addEventListener("mouseover", () => {
      if (isSpSize()) return;
      const myId = elm.dataset.id;
      if (!myId) return;
      const companyName = $(elm).find(".p-area__name").text();
      activatePoint(myId, companyName);
    });

    elm.addEventListener("mouseleave", () => {
      if (isSpSize()) return;
      const myId = elm.dataset.id;
      if (!myId) return;
      const companyName = $(elm).find(".p-area__name").text();
      inactivatePoint(myId, companyName);
    });
  });
};

export { init };
